module.exports = __webpack_public_path__ + "img/thousand-sunny.f1354b75.gif";